// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"dam-5"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M16 3H8V15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M20 21V3H16V21H20Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M4 21V3H8V21H4Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 3V21M4 3H8M4 3H3M20 3V21M20 3H16M20 3H21M4 21H3M4 21C9 21 3 21 8 21M20 21H21M20 21H16M8 3H16M8 3C8 8.9797 8 9.84222 8 15M8 21H16M8 21C8 19.5597 8 16.2423 8 15M16 3V15M16 21V15M8 15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-dam-5')
export default class Dam5Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-5',
    }
  }
}
